export const ACTIVITY_PAGE_SIZE = 5;
